import ContactFormComponent from '../../../../../components/Views/ContactForm/ContactForm';

export default ContactFormComponent;
